import { Route, Switch } from "react-router-dom";
import TermsAndConditionsPage from "../Pages/termsAndConditionPage";
import { BestWaterAppTermsAndConditionsPage } from "../Pages/bestWaterAppTermsAndConditionsPage";
import React from "react";
import ProAppTermsAndConditionsPage from "../Pages/proAppTermsAndConditionsPage";

export default function TermsAndConditionsRoutes() {
  return (
    <Switch>
      <Route
        exact
        path="/TermsAndConditions"
        component={TermsAndConditionsPage}
      />
      <Route
        path="/TermsAndConditions/BWTBestWaterApp"
        component={BestWaterAppTermsAndConditionsPage}
      />
      <Route
        path="/TermsAndConditions/BWTProApp"
        component={ProAppTermsAndConditionsPage}
      />
    </Switch>
  );
}
